import { render } from "./EdaWorkspace.vue?vue&type=template&id=753456e8"
import script from "./EdaWorkspace.vue?vue&type=script&lang=js"
export * from "./EdaWorkspace.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__